export const defaultImageUrl =
  'https://fe-static.cassmall.com/assets/images/20260107190609/default_gray.svg';
